import { render, staticRenderFns } from "./internalActionDetail.vue?vue&type=template&id=45712d8d"
import script from "./internalActionDetail.vue?vue&type=script&lang=js"
export * from "./internalActionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45712d8d')) {
      api.createRecord('45712d8d', component.options)
    } else {
      api.reload('45712d8d', component.options)
    }
    module.hot.accept("./internalActionDetail.vue?vue&type=template&id=45712d8d", function () {
      api.rerender('45712d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalActionDetail.vue"
export default component.exports